/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import {  IpBill } from '../../../interfaces/masters/ipbill';

@Injectable()
export class IPBillApi {

  private readonly apiController: string = 'tenants/';

  constructor(private api: HttpService) { }






  addIPBillMaster(url: string, data: any): Observable<any> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept', 'application/vnd.ezovion.hateoas+json');
    return this.api.directPost(url, data, header);
  }


  ipBillMasterList(url: string, options?: any): Observable<any[]> {

    const header = new HttpHeaders({ "Accept": "application/vnd.ezovion.hateoas+json" });

    return this.api.get(this.apiController + url, { headers: { "Accept": "application/vnd.ezovion.hateoas+json", 'Content-Type': "application/json" } });
 }

 list(url: string, options?: any): Observable<any[]> {
  const header = new HttpHeaders({ "Accept": "application/vnd.ezovion.hateoas+json" });
  return this.api.get(url, { headers: { "Accept": "application/vnd.ezovion.hateoas+json", 'Content-Type': "application/json" } });
}


 updateIPBillMaster(url: string, data: any):Observable<any>{
  let header = new HttpHeaders();
  header.append('Content-Type', 'applications/json');
  header.append('Accept','application/vnd.ezovion.hateoas+json');
  return this.api.directPut( url,data, header);
}

cancelBill(url: string, data):Observable<any>{
  let header = new HttpHeaders();
  header.append('Content-Type', 'applications/json');
  header.append('Accept','application/vnd.ezovion.hateoas+json');
  return this.api.directPut( url, data, header);
}

searchList(url: string, data:any, options?: any): Observable<any[]> {
  const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  //header.append('Content-Type', 'applications/json');
  //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
  //header.append('Accept','application/vnd.ezovion.hateoas+json');
  return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
}
}
